import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { CategoryService } from './categories.service';
import * as actions from './categories.actions';

@Injectable()
export class CategoriesEffect {
    constructor(
        private actions$: Actions,
        private categoriesService: CategoryService,
    ) { }

    createCategories$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_CATEGORY),
        map((action: actions.CreateCategoryAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.createCategories(state).pipe(
                map(data => new actions.CreateCategorySuccessAction(data)),
                catchError(err => of(new actions.CreateCategoryFailAction(err)))
            );
        })
    ));

    getCategoriesList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_CATEGORIES_LIST),
        map((action: actions.GetCategoriesListAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.getCategoriesList(state).pipe(
                map(data => new actions.GetCategoriesListSuccesssAction(data)),
                catchError(err => of(new actions.GetCategoriesListFailAction(err)))
            );
        })
    ));

    getCategoriesItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_CATEGORIES_ITEM),
        map((action: actions.GetCategoriesItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.getCategoriesItem(id).pipe(
                map(data => new actions.GetCategoriesItemSuccessAction(data)),
                catchError(err => of(new actions.GetCategoriesItemFailAction(err)))
            );
        })
    ));

    updateCategoriesItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_CATEGORIES_ITEM),
        map((action: actions.UpdateCategoriesItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            const params = state.params;
            return this.categoriesService.updateCategories(id, params).pipe(
                map(data => new actions.UpdateCategoriesItemSuccessAction(data)),
                catchError(err => of(new actions.UpdateCategoriesItemFailAction(err)))
            );
        })
    ));

    deleteCategoriesItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_CATEGORIES_ITEM),
        map((action: actions.RemoveCategoriesItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.deleteCategories(id).pipe(
                map(data => new actions.RemoveCategoriesItemSuccessAction(data)),
                catchError(err => of(new actions.RemoveCategoriesItemFailAction(err)))
            );
        })
    ));


    createSliderItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_SLIDER_ITEMS),
        map((action: actions.CreateSliderItemAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.createSliderItem(state).pipe(
                map(data => new actions.CreateSliderItemSuccessAction(data)),
                catchError(err => of(new actions.CreateSliderItemFailAction(err)))
            );
        })
    ));
    getSliderItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_SLIDER_ITEM),
        map((action: actions.GetSliderItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.getSliderItem(id).pipe(
                map(data => new actions.GetSliderItemSuccessAction(data)),
                catchError(err => of(new actions.GetSliderItemFailAction(err)))
            );
        })
    ));
    getSliderList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_SLIDER_LIST),
        map((action: actions.GetSliderListAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.getSliderList(state).pipe(
                map(data => new actions.GetSliderListSuccessAction(data)),
                catchError(err => of(new actions.GetSliderListFailAction(err)))
            );
        })
    ));
    removeSliderItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_SLIDER_ITEM),
        map((action: actions.RemoveSliderItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.removeSliderItem(id).pipe(
                map(data => new actions.RemoveSliderItemSuccessAction(data)),
                catchError(err => of(new actions.RemoveSliderItemFailAction(err)))
            );
        })
    ));
    updateSliderItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_SLIDER_ITEM),
        map((action: actions.UpdateSliderItemAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.updateSliderItem(state).pipe(
                map(data => new actions.UpdateSliderItemSuccessAction(data)),
                catchError(err => of(new actions.UpdateSliderItemFailAction(err)))
            );
        })
    ));


    createPdfItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_PDF_ITEM),
        map((action: actions.CreatePdfItemAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.createPdfItem(state).pipe(
                map(data => new actions.CreatePdfItemSuccessAction(data)),
                catchError(err => of(new actions.CreatePdfItemFailAction(err)))
            );
        })
    ));
    getPdfItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_PDF_ITEM),
        map((action: actions.GetPdfItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.getPdfItem(id).pipe(
                map(data => new actions.GetPdfItemSuccessAction(data)),
                catchError(err => of(new actions.GetPdfItemFailAction(err)))
            );
        })
    ));
    getPdfList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_PDF_LIST),
        map((action: actions.GetPdfListAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.getPdfList(state).pipe(
                map(data => new actions.GetPdfListSuccessAction(data)),
                catchError(err => of(new actions.GetPdfListFailAction(err)))
            );
        })
    ));
    removePdfItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.DELETE_PDF_ITEM),
        map((action: actions.DeletePdfItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.removePdfItem(id).pipe(
                map(data => new actions.DeletePdfItemSuccessAction(data)),
                catchError(err => of(new actions.DeletePdfItemFailAction(err)))
            );
        })
    ));
    updatePdfItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_PDF_ITEM),
        map((action: actions.UpdatePdfItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            const params = state.params;
            return this.categoriesService.updatePdfItem(id, params).pipe(
                map(data => new actions.UpdatePdfItemSuccessAction(data)),
                catchError(err => of(new actions.UpdatePdfItemFailAction(err)))
            );
        })
    ));



    createSlider$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_SLIDER),
        map((action: actions.CreateSliderAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.createSlider(state).pipe(
                map(data => new actions.CreateSliderSuccessAction(data)),
                catchError(err => of(new actions.CreateSliderFailAction(err)))
            );
        })
    ));
    getSlider$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_SLIDER),
        map((action: actions.GetSliderAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.getSlider(id).pipe(
                map(data => new actions.GetSliderSuccessAction(data)),
                catchError(err => of(new actions.GetSliderFailAction(err)))
            );
        })
    ));
    getSliders$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_SLIDERS),
        map((action: actions.GetSlidersAction) => action.payload),
        switchMap(state => {
            return this.categoriesService.getSliders(state).pipe(
                map(data => new actions.GetSlidersSuccessAction(data)),
                catchError(err => of(new actions.GetSlidersFailAction(err)))
            );
        })
    ));
    removeSlider$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_SLIDER),
        map((action: actions.RemoveSliderAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.categoriesService.removeSlider(id).pipe(
                map(data => new actions.RemoveSliderSuccessAction(data)),
                catchError(err => of(new actions.RemoveSliderFailAction(err)))
            );
        })
    ));
    updateSlider$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_SLIDER),
        map((action: actions.UpdateSliderAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            const params = state.params;
            return this.categoriesService.updateSlider(id, params).pipe(
                map(data => new actions.UpdateSliderSuccessAction(data)),
                catchError(err => of(new actions.UpdateSliderFailAction(err)))
            );
        })
    ));
}